document.addEventListener('turbo:load', () => {
  const $ = id => document.getElementById(id)
  const colours = ['#7C3AED', '#16745A', '#B35E14', '#3366B2', '#A63375']
  const ordinal = i => String(i + 1) + (['st', 'nd', 'rd'][i] || 'th')
  const file = $('signing-upload-file')
  if (file) {
    const submit = () => {
      if (!file.files.length) return
      if (!file.files[0].name.toLowerCase().endsWith('.pdf')) { $('signing-upload-status').textContent = 'Please choose a PDF document.'; file.value = ''; return }
      $('signing-upload-status').textContent = 'Uploading ' + file.files[0].name + '…'
      $('signing-choose-file').disabled = true
      $('signing-upload-form').requestSubmit()
    }
    $('signing-choose-file').onclick = () => file.click()
    file.onchange = submit
    $('signing-dropzone').ondragover = event => event.preventDefault()
    $('signing-dropzone').ondrop = event => { event.preventDefault(); file.files = event.dataTransfer.files; submit() }
  }
  const root = $('sw-people')
  if (root) {
    let next = root.children.length
    const renumber = () => [...root.children].forEach((row, i) => {
      row.querySelector('[data-party-label]').textContent = ordinal(i) + ' Party'
      row.querySelector('.dot').style.setProperty('--party', colours[i % colours.length])
      row.querySelector('[data-remove]').disabled = root.children.length === 1
    })
    root.onclick = event => {
      const remove = event.target.closest('[data-remove]')
      if (!remove || root.children.length === 1) return
      const row = remove.closest('.sw-row')
      if (row.dataset.hasFields === 'true') {
        if (!window.confirm('Remove this signer and all their placed fields?')) return
        $('confirm-remove').value = '1'
      }
      row.remove()
      renumber()
    }
    $('sw-add').onclick = () => {
      if (root.children.length >= 10) { $('error').textContent = 'You can add up to 10 signers.'; return }
      const row = root.firstElementChild.cloneNode(true)
      row.dataset.hasFields = 'false'
      row.querySelectorAll('input').forEach(input => {
        input.name = input.name.replace(/people\[\d+\]/, 'people[' + next + ']')
        input.value = ''
        input.removeAttribute('id')
      })
      next++
      root.append(row)
      renumber()
      row.querySelector('input[type=text]').focus()
    }
    renumber()
  }
  const form = $('review-form')
  if (form) {
    const person = $('email-person'), frequency = $('sw-frequency')
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    $('reminder-timezone').value = zone
    const update = () => {
      const option = person.selectedOptions[0]
      $('email-to').textContent = 'To: ' + option.dataset.name + ' <' + option.dataset.email + '>'
      $('email-greeting').textContent = 'Hi ' + option.dataset.name + ','
      $('reminder-greeting').textContent = $('email-greeting').textContent
      $('email-preview-subject').textContent = $('email-subject').value
      $('email-preview-message').textContent = $('email-message').value
      const freq = frequency.value, off = freq === 'off', custom = freq === 'custom'
      $('sw-custom').hidden = !custom
      $('custom-days').required = custom
      for (const id of ['reminder-limit-wrap','reminder-email','reminder-schedule','reminder-rule']) $(id).hidden = off
      const interval = custom ? Number($('custom-days').value) : freq === 'weekly' ? 7 : 1
      const limit = Number($('reminder-limit').value)
      const valid = off || !custom || (Number.isInteger(interval) && interval >= 1 && interval <= 90)
      $('custom-days').setCustomValidity(valid ? '' : 'Choose a whole number from 1 to 90.')
      const now = new Date()
      let summary = 'No automatic reminders.'
      $('schedule-dates').replaceChildren()
      if (!off && valid) {
        summary = (freq === 'monthly' ? 'Every calendar month' : 'Every ' + (interval === 1 ? 'day' : interval + ' days')) + ', up to ' + limit + ' reminder' + (limit === 1 ? '' : 's') + ' per unfinished signer.'
        for (let i = 1; i <= Math.min(limit, 3); i++) {
          const date = new Date(now)
          if (freq === 'monthly') { date.setDate(1); date.setMonth(now.getMonth() + i); const last = new Date(date.getFullYear(),date.getMonth()+1,0).getDate(); date.setDate(Math.min(now.getDate(),last)) } else date.setDate(now.getDate() + interval * i)
          const li = document.createElement('li')
          li.textContent = date.toLocaleString(undefined, {month:'short',day:'numeric',year:'numeric',hour:'2-digit',minute:'2-digit'})
          $('schedule-dates').append(li)
        }
        if (limit > 3) { const li = document.createElement('li'); li.textContent = 'Then ' + (limit - 3) + ' more at the same interval.'; $('schedule-dates').append(li) }
        $('schedule-summary').textContent = summary
        $('schedule-zone').textContent = 'Times shown in ' + zone + '. Starts one full interval after sending.' + (freq === 'monthly' ? ' Uses the same day each month, or the last day for shorter months.' : '')
      } else if (!valid) {
        $('schedule-summary').textContent = 'Choose a custom interval of 1–90 whole days.'
        $('schedule-zone').textContent = ''
        summary = 'Reminder interval needs attention.'
      }
      $('send-summary').textContent = person.options.length + ' separate invitation emails • Each recipient sees only their own invitation. ' + summary + ' All signers are invited together; party numbers do not set a signing order.'
      $('send-request').disabled = !valid || !$('email-subject').value.trim() || !$('email-message').value.trim()
    }
    form.addEventListener('input', update)
    form.addEventListener('change', update)
    person.addEventListener('change', update)
    update()
  }
  document.querySelectorAll('[data-workflow-step]').forEach(button => {
    button.onclick = () => {
      const step = Number(button.dataset.workflowStep)
      const base = document.querySelector('[data-workflow-path]')?.dataset.workflowPath || location.pathname
      if (step === 0) { location.href = '/service/signing_requests/new'; return }
      if (file) { $('signing-choose-file').click(); return }
      if (root && step > 1) { $('sw-signers').requestSubmit(); return }
      if (document.querySelector('.sw-builder')) {
        if (step === 3) { document.querySelector('.rail-bottom button').click(); return }
        if (step === 1 && !window.confirm('Return to signers? Save your fields by choosing Review request first.')) return
      }
      location.href = base + '?step=' + (step === 1 ? 'signers' : step === 2 ? 'fields' : 'settings')
    }
  })
})
